/**
 * @return {String} document title
 */

export function documentTitle() {
  return document.title;
}
